var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-event-calendar",attrs:{"id":'elem-' + _vm.config.id}},[(_vm.ready)?_c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }